import React from 'react'
import img2028 from '../components/images/dmeesho.png'
const events = () => {
    return (

        <>
            <div className="row  m-2">
                <img src={img2028} alt='meesho' />
            </div>
            <div className="row m-2">
                <div className="col-sm ">

                    <h2 className='p-2'>Meesho Account Management Services
                    </h2>
                    <p>Elevate your Meesho business with our specialized account management services. We handle all aspects of your Meesho store, letting you focus on your products while we drive your growth and success. </p>
                </div>
                <div className="col-sm ">
                    {/* <img src={img201} alt='Queryimg' /> */}
                </div>
            </div>
            <ul >
                <h3 className='text-info'> Key Services We Offer:</h3>
                <li><b>•	Product Cataloging:</b> Optimize listings with accurate descriptions, quality images, and relevant keywords to boost visibility. </li>
                <li><b>•	Advertising Campaign:</b>Execute targeted ads to increase product visibility and drive sales.</li>
                <li><b>•	Account Health:</b> Maintain the health of your Meesho account, ensuring policy compliance. </li>
                <li><b>•	Order Processing:</b>Manage orders from receipt to delivery for efficient fulfillment. </li>
                <li><b>•	Payment Reconciliation:</b>Record transactions accurately and resolve discrepancies promptly. </li>
                <li><b>•	Keyword Optimization:</b> Enhance search ranking with optimized keywords for listings and ads. </li>
                <li><b>•	Basic Training:</b>Provide training to help you effectively manage your Meesho account. </li>
                <li><b>•	Sales Boost:</b> Implement strategies to increase sales, including product promotion and optimized advertising.</li>
                <p>Unlock your potential on Meesho with our expert account management services. Contact E Seller Support today to take your Meesho business to new heights.</p>
            </ul>
        </>
    )
}

export default events